//App
import useIconStyles from "./styles";
import { IconProps } from "../../../types";

const BlockIcon = (props: IconProps) => {
    const { iconText, pendingText = "Deactivate" } = props;
    const iconStyles = useIconStyles();

    return (
        <div style={iconStyles.flex}>
            <i className="bi bi-ban" style={iconStyles.deleteIcon}></i>
            <div>
                {iconText} {pendingText}
            </div>
        </div>
    );
};

export default BlockIcon;
